export enum ContentType {
    PROMO_STANDARD = "PROMO_STANDARD",
    PROMO_EXPANDED = "PROMO_EXPANDED",
    PLAN_STANDARD = "PLAN_STANDARD",
    PLAN_EXPANDED = "PLAN_EXPANDED"
}